var KUALA_STICKY_ADDED_MS = 1700;
if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
          isAdded: 'sticky-atc-bar--added',
        };

        this._addedTimer = null;
        this._initiatedAdd = false;

        if (this.submitEl) {
          this.submitEl.addEventListener('click', this.onClick.bind(this));
        }
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('[data-sticky-cta], [type="submit"]'));
      }

      get labelEl() {
        return this.querySelector('[data-sticky-cta-label]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.init();

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this._initiatedAdd = false;
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
          if (this._initiatedAdd) {
            this._initiatedAdd = false;
            this.showAddedState();
          }
        });
      }

      disconnectedCallback() {
        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this._addedTimer) {
          clearTimeout(this._addedTimer);
          this._addedTimer = null;
        }

        this.setBarVisible(false);
        if (this.observer) this.observer.disconnect();
      }

      setBarVisible(visible) {
        this.classList.toggle(this.classes.isOpen, visible);
        if (this.classList.contains('sticky-atc-bar--sale-countdown')) {
          var desktop = window.matchMedia('(min-width: 768px)').matches;
          var showLift = visible && desktop;
          document.documentElement.classList.toggle('pdp-sale-countdown-sticky-visible', showLift);
          document.documentElement.style.setProperty(
            '--sticky-atc-bar-height',
            showLift ? this.offsetHeight + 'px' : '0px'
          );
        }
      }

      init() {
        if (!this.productFormActions) {
          this.setBarVisible(false);
          return;
        }

        const observeTarget =
          this.productFormActions.querySelector('[name="add"]') || this.productFormActions;
        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.setBarVisible(isAboveViewport);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(observeTarget);
        this.syncWithMainProductForm();
      }

      onClick() {
        if (!this.submitEl || this.submitEl.disabled) return;
        this._initiatedAdd = true;
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        if (!this.submitEl) return;
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      showAddedState() {
        var self = this;
        this.classList.add(this.classes.isAdded);
        if (this._addedTimer) {
          clearTimeout(this._addedTimer);
        }
        this._addedTimer = setTimeout(function () {
          self.classList.remove(self.classes.isAdded);
          self._addedTimer = null;
        }, KUALA_STICKY_ADDED_MS);
      }

      scrollToTop(target, offset = 200) {
        const scrollIntoView = (selector, offset) => {
          window.scrollTo({
            behavior: 'smooth',
            top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
          });
        };

        scrollIntoView(target, offset);
      }

      updateButton(disable, text, modifyClass) {
        if (typeof disable === 'undefined') disable = true;
        if (!this.submitEl) return;
        var labelEl = this.labelEl;
        var self = this;
        var getAddToCartText = function () {
          if (self.mainProductInfo && self.mainProductInfo.currentVariant && typeof window.kualaPickAtcLabel === 'function') {
            return window.kualaPickAtcLabel(self.mainProductInfo.currentVariant.id, self.dataset.section);
          }
          return FoxTheme.variantStrings.addToCart;
        };
        if (disable) {
          this.submitEl.setAttribute('disabled', 'disabled');
          if (text && labelEl) labelEl.textContent = text;
        } else {
          this.submitEl.removeAttribute('disabled');
          if (labelEl) labelEl.textContent = getAddToCartText();
        }
      }

      updateVariantLine(variant) {
        var el = this.querySelector('[data-sticky-variant-line]');
        if (!el) return;
        var hasDefault = this.dataset.hasDefaultVariant === 'true';
        if (!hasDefault && variant && variant.title) {
          el.textContent = variant.title;
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      }

      updatePrice(variant) {
        if (!variant) return;
        var moneyFormat = FoxTheme.settings.moneyFormat;
        var currentEls = this.querySelectorAll('[data-sticky-price]');
        var compareWraps = this.querySelectorAll('[data-sticky-compare]');

        currentEls.forEach(function (currentEl) {
          currentEl.innerHTML = FoxTheme.Currency.formatMoney(variant.price, moneyFormat);
        });

        compareWraps.forEach(function (compareWrap) {
          var compareValue = compareWrap.querySelector('[data-sticky-compare-value]');
          if (!compareValue) return;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareValue.innerHTML = FoxTheme.Currency.formatMoney(variant.compare_at_price, moneyFormat);
            compareWrap.classList.remove('hidden');
            compareWrap.removeAttribute('aria-hidden');
          } else {
            compareValue.innerHTML = '';
            compareWrap.classList.add('hidden');
            compareWrap.setAttribute('aria-hidden', 'true');
          }
        });

        this.updateMobileLine(variant);
      }

      updateMobileLine(variant) {
        var el = this.querySelector('[data-sticky-mobile-meta]');
        if (!el) return;
        var title = this.dataset.productShortTitle || this.dataset.productTitle || '';
        var option = variant && this.dataset.hasDefaultVariant !== 'true' && variant.title ? variant.title : '';
        var bits = [];
        if (title) bits.push(title);
        if (option) bits.push(option);
        el.textContent = bits.join(' · ');
      }

      updateImage(variant) {
        var img = this.querySelector('.sticky-atc-bar__product-image img');
        if (!img || !variant || !variant.featured_image || !variant.featured_image.src) return;
        var src = variant.featured_image.src;
        img.src = src;
        img.removeAttribute('srcset');
      }

      syncWithMainProductForm() {
        var self = this;
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
          if (!self.mainProductInfo) return;
          var isMainProduct = event.data.sectionId === self.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          var variant = event.data.variant;
          self.updatePrice(variant);
          self.updateVariantLine(variant);
          self.updateImage(variant);
          self.updateButton(true, '', false);
          if (!variant) {
            self.updateButton(true, '', true);
          } else {
            var sectionId = self.mainProductInfo && self.mainProductInfo.dataset ? self.mainProductInfo.dataset.section : null;
            var disable =
              typeof window.kualaIsAtcDisabled === 'function' && sectionId
                ? window.kualaIsAtcDisabled(variant.id, sectionId)
                : !variant.available;
            self.updateButton(disable, disable ? FoxTheme.variantStrings.soldOut : '');
          }
        });
      }
    }
  );
}
